module.exports = __webpack_public_path__ + "fonts/GeneralSans-Medium.25c8b884.ttf";